import { render, staticRenderFns } from "./ProductContent.component.vue?vue&type=template&id=5c966b60&scoped=true"
import script from "./ProductContent.component.vue?vue&type=script&lang=js"
export * from "./ProductContent.component.vue?vue&type=script&lang=js"
import style0 from "./ProductContent.component.vue?vue&type=style&index=0&id=5c966b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c966b60",
  null
  
)

export default component.exports